/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Invite_StatusInputs */

const en_mobile_referral_invite_status = /** @type {(inputs: Mobile_Referral_Invite_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite status`)
};

const es_mobile_referral_invite_status = /** @type {(inputs: Mobile_Referral_Invite_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de invitaciones`)
};

/**
* | output |
* | --- |
* | "Invite status" |
*
* @param {Mobile_Referral_Invite_StatusInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_invite_status = /** @type {((inputs?: Mobile_Referral_Invite_StatusInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Invite_StatusInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_invite_status(inputs)
	return en_mobile_referral_invite_status(inputs)
});